var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-section" },
    [
      _c(
        "div",
        { staticClass: "section-header" },
        [
          _c("h3", { staticClass: "section-title" }, [
            _vm._v("酷家乐下单\n      "),
            _vm.contractNo
              ? _c("span", { staticClass: "contract-no" }, [
                  _vm._v("(合同号: " + _vm._s(_vm.contractNo) + ")"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.sourceContractNo
              ? _c("span", { staticClass: "contract-no source-contract-no" }, [
                  _vm._v("(源合同号: " + _vm._s(_vm.sourceContractNo) + ")"),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "small",
                plain: "",
                loading: _vm.refreshLoading,
              },
              on: { click: _vm.refreshData },
            },
            [_c("i", { staticClass: "el-icon-refresh" }), _vm._v(" 刷新\n    ")]
          ),
          _vm._v(" "),
          _vm.coolHomePlanList.length > 0
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small", plain: "" },
                  on: { click: _vm.toggleAllExpand },
                },
                [
                  _c("i", {
                    class: _vm.isAllExpanded
                      ? "el-icon-arrow-up"
                      : "el-icon-arrow-down",
                  }),
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.isAllExpanded ? "全部收起" : "全部展开") +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.checkPer("orders:plan")
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.openCoolHomeDialog },
                },
                [_vm._v("关联酷家乐方案")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                type: "success",
                size: "small",
                disabled: _vm.selectedAuditIds.length === 0,
              },
              on: { click: _vm.handleBatchCreateOrder },
            },
            [
              _vm._v(
                "批量下单" +
                  _vm._s(
                    _vm.selectedAuditIds.length > 0
                      ? "(" + _vm.selectedAuditIds.length + ")"
                      : ""
                  )
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                type: "warning",
                size: "small",
                disabled: !_vm.canBatchSetTryInstall,
              },
              on: {
                click: function ($event) {
                  return _vm.handleBatchTryInstall(true)
                },
              },
            },
            [
              _vm._v(
                "批量试装" +
                  _vm._s(
                    _vm.selectedAuditIds.length > 0
                      ? "(" + _vm.selectedAuditIds.length + ")"
                      : ""
                  )
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                type: "info",
                size: "small",
                disabled: !_vm.canBatchCancelTryInstall,
              },
              on: {
                click: function ($event) {
                  return _vm.handleBatchTryInstall(false)
                },
              },
            },
            [
              _vm._v(
                "取消试装" +
                  _vm._s(
                    _vm.selectedAuditIds.length > 0
                      ? "(" + _vm.selectedAuditIds.length + ")"
                      : ""
                  )
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.syncLoading || _vm.orderLoading,
              expression: "syncLoading || orderLoading",
            },
          ],
          staticStyle: { "margin-top": "20px" },
          attrs: {
            "element-loading-text": "正在处理，请稍候...",
            "element-loading-spinner": "el-icon-loading",
            "element-loading-background": "rgba(255, 255, 255, 0.8)",
          },
        },
        [
          _c(
            "el-table",
            {
              staticClass: "outer-table",
              attrs: {
                data: _vm.coolHomePlanList,
                "row-key": "rowId",
                border: "",
                size: "small",
                "expand-row-keys": _vm.expandedRows,
              },
              on: { "row-click": _vm.handleRowClick },
            },
            [
              _c("el-table-column", {
                attrs: { type: "expand" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        props.row.designSchemeAudits &&
                        props.row.designSchemeAudits.length > 0
                          ? _c(
                              "div",
                              { staticClass: "expand-content" },
                              [
                                _c(
                                  "el-table",
                                  {
                                    ref: "auditTable_" + props.row.rowId,
                                    staticStyle: { "margin-bottom": "10px" },
                                    attrs: {
                                      data: props.row.designSchemeAudits,
                                      size: "small",
                                      "row-key": "rowId",
                                      border: "",
                                    },
                                    on: {
                                      "row-click": _vm.handleAuditRowClick,
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: { type: "expand" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.boms &&
                                                scope.row.boms.length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "boms-expand",
                                                      },
                                                      [
                                                        _c(
                                                          "el-table",
                                                          {
                                                            attrs: {
                                                              data: scope.row
                                                                .boms,
                                                              size: "mini",
                                                              border: "",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "el-table-column",
                                                              {
                                                                attrs: {
                                                                  prop: "code",
                                                                  label: "编码",
                                                                  "min-width":
                                                                    "150",
                                                                },
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "el-table-column",
                                                              {
                                                                attrs: {
                                                                  prop: "barcode",
                                                                  label:
                                                                    "部件编码",
                                                                  "min-width":
                                                                    "150",
                                                                },
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "el-table-column",
                                                              {
                                                                attrs: {
                                                                  prop: "name",
                                                                  label:
                                                                    "物料名称",
                                                                  "min-width":
                                                                    "150",
                                                                },
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "el-table-column",
                                                              {
                                                                attrs: {
                                                                  prop: "mat",
                                                                  label: "材质",
                                                                  "min-width":
                                                                    "100",
                                                                },
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "el-table-column",
                                                              {
                                                                attrs: {
                                                                  prop: "color",
                                                                  label: "颜色",
                                                                  "min-width":
                                                                    "100",
                                                                },
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "el-table-column",
                                                              {
                                                                attrs: {
                                                                  prop: "length",
                                                                  label: "长度",
                                                                  "min-width":
                                                                    "80",
                                                                },
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "el-table-column",
                                                              {
                                                                attrs: {
                                                                  prop: "width",
                                                                  label: "宽度",
                                                                  "min-width":
                                                                    "80",
                                                                },
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "el-table-column",
                                                              {
                                                                attrs: {
                                                                  prop: "thk",
                                                                  label: "厚度",
                                                                  "min-width":
                                                                    "80",
                                                                },
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "el-table-column",
                                                              {
                                                                attrs: {
                                                                  prop: "quantity",
                                                                  label: "数量",
                                                                  "min-width":
                                                                    "80",
                                                                },
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "el-table-column",
                                                              {
                                                                attrs: {
                                                                  prop: "createUserName",
                                                                  label:
                                                                    "创建人",
                                                                  "min-width":
                                                                    "100",
                                                                },
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "el-table-column",
                                                              {
                                                                attrs: {
                                                                  prop: "createTime",
                                                                  label:
                                                                    "创建时间",
                                                                  "min-width":
                                                                    "160",
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "boms-expand-empty",
                                                        staticStyle: {
                                                          "text-align":
                                                            "center",
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "暂无物料清单"
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        type: "index",
                                        label: "序号",
                                        width: "60",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "el-table-column",
                                      {
                                        attrs: { label: "操作", width: "150" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  scope.row.productionStatus ===
                                                    "未提交" ||
                                                  scope.row.productionStatus ===
                                                    "回退" ||
                                                  scope.row.productionStatus ===
                                                    "退回"
                                                    ? _c("el-checkbox", {
                                                        staticStyle: {
                                                          "margin-right": "8px",
                                                        },
                                                        on: {
                                                          change: function (
                                                            val
                                                          ) {
                                                            return _vm.handleAuditCheckChange(
                                                              val,
                                                              scope.row,
                                                              props.row
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row._checked,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "_checked",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row._checked",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  scope.row.productionStatus ===
                                                    "未提交" &&
                                                  _vm.checkPer("orders:create")
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "primary",
                                                            size: "mini",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleCreateOrderFromExpand(
                                                                scope.row,
                                                                props.row
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("下单")]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  (scope.row
                                                    .productionStatus ===
                                                    "退回" ||
                                                    scope.row
                                                      .productionStatus ===
                                                      "回退") &&
                                                  (scope.row.auditStatus ===
                                                    "待审核" ||
                                                    scope.row.auditStatus ===
                                                      "审核中" ||
                                                    scope.row.auditStatus ===
                                                      "已退回") &&
                                                  _vm.checkPer("orders:create")
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "primary",
                                                            size: "mini",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleCreateOrderFromExpand(
                                                                scope.row,
                                                                props.row
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("重新提交")]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c(
                                          "template",
                                          { slot: "header" },
                                          [
                                            _c(
                                              "el-checkbox",
                                              {
                                                attrs: {
                                                  indeterminate:
                                                    props.row
                                                      .designSchemeAudits &&
                                                    props.row.designSchemeAudits
                                                      .filter(function (a) {
                                                        return (
                                                          a.productionStatus ===
                                                            "未提交" ||
                                                          a.productionStatus ===
                                                            "回退"
                                                        )
                                                      })
                                                      .some(function (a) {
                                                        return a._checked
                                                      }) &&
                                                    !props.row.designSchemeAudits
                                                      .filter(function (a) {
                                                        return (
                                                          a.productionStatus ===
                                                            "未提交" ||
                                                          a.productionStatus ===
                                                            "退回"
                                                        )
                                                      })
                                                      .every(function (a) {
                                                        return a._checked
                                                      }),
                                                  checked:
                                                    props.row
                                                      .designSchemeAudits &&
                                                    props.row.designSchemeAudits.filter(
                                                      function (a) {
                                                        return (
                                                          a.productionStatus ===
                                                            "未提交" ||
                                                          a.productionStatus ===
                                                            "回退"
                                                        )
                                                      }
                                                    ).length > 0 &&
                                                    props.row.designSchemeAudits
                                                      .filter(function (a) {
                                                        return (
                                                          a.productionStatus ===
                                                            "未提交" ||
                                                          a.productionStatus ===
                                                            "退回"
                                                        )
                                                      })
                                                      .every(function (a) {
                                                        return a._checked
                                                      }),
                                                },
                                                on: {
                                                  change: function (val) {
                                                    return _vm.handleAuditSelectAll(
                                                      val,
                                                      props.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("全选")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "关联特殊申请",
                                        width: "180",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.productionStatus ===
                                                  "未提交" ||
                                                scope.row.productionStatus ===
                                                  "回退"
                                                  ? _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          multiple: "",
                                                          placeholder: "请选择",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleSpecialApplyChange(
                                                              scope.row
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .specialApplication,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "specialApplication",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.specialApplication",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.specialApplyOptions,
                                                        function (item) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: item.id,
                                                              attrs: {
                                                                label:
                                                                  item.title,
                                                                value:
                                                                  item.title,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row
                                                            .specialApplication
                                                            ? scope.row.specialApplication.join(
                                                                ", "
                                                              )
                                                            : ""
                                                        )
                                                      ),
                                                    ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: { label: "原单号", width: "300" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.productionStatus ===
                                                  "未提交" ||
                                                scope.row.productionStatus ===
                                                  "回退"
                                                  ? _c("el-autocomplete", {
                                                      staticStyle: {
                                                        width: "100%",
                                                      },
                                                      attrs: {
                                                        "fetch-suggestions":
                                                          function (query, cb) {
                                                            return _vm.originalOrderSearch(
                                                              query,
                                                              cb,
                                                              scope.row
                                                            )
                                                          },
                                                        placeholder:
                                                          "请输入或选择原单号",
                                                        clearable: "",
                                                        placement: "top",
                                                      },
                                                      on: {
                                                        select: function (
                                                          item
                                                        ) {
                                                          scope.row.originalOrder =
                                                            item.productionOrder
                                                          _vm.handleOriginalOrderChange(
                                                            scope.row
                                                          )
                                                        },
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleOriginalOrderChange(
                                                            scope.row
                                                          )
                                                        },
                                                        focus:
                                                          _vm.getOriginalOrderList,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row
                                                            .originalOrder,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "originalOrder",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.originalOrder",
                                                      },
                                                    })
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row
                                                            .originalOrder ||
                                                            "-"
                                                        )
                                                      ),
                                                    ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "auditName",
                                        label: "审核单名称",
                                        "min-width": "180",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "auditStatus",
                                        label: "审核状态",
                                        "min-width": "100",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "productionOrder",
                                        label: "单号",
                                        "min-width": "180",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "productionStatus",
                                        label: "销售单状态",
                                        "min-width": "120",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "createTime",
                                        label: "创建时间",
                                        "min-width": "160",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "toolType",
                                        label: "工具类型",
                                        "min-width": "150",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _c("div", { staticClass: "expand-content-empty" }, [
                              _c("span", [_vm._v("暂无提审单信息")]),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "60" },
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: { label: "操作", "min-width": "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.designSchemeAudits &&
                          scope.row.designSchemeAudits.some(function (a) {
                            return (
                              a.productionStatus === "未提交" ||
                              a.productionStatus === "回退"
                            )
                          })
                            ? _c("el-checkbox", {
                                staticStyle: { "margin-right": "8px" },
                                on: {
                                  change: function ($event) {
                                    return _vm.handleRowCheckChange(scope.row)
                                  },
                                },
                                model: {
                                  value: scope.row._checked,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "_checked", $$v)
                                  },
                                  expression: "scope.row._checked",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "operation-buttons",
                              staticStyle: { display: "inline-block" },
                            },
                            [
                              _vm.checkPer("orders:plan")
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.handleDesign(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("设计")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkPer("orders:plan") && !scope.row.isOrder
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "danger", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.handleDeleteScheme(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkPer("orders:plan") && !scope.row.isOrder
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "info", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.handleUnbindScheme(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("取消关联")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkPer("orders:plan")
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "warning", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.handleSyncData(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("同步数据")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: {
                            indeterminate: _vm.isIndeterminate,
                            checked: _vm.isAllChecked,
                          },
                          on: { change: _vm.handleSelectAll },
                        },
                        [_vm._v("全选")]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "designScheme",
                  label: "设计方案号",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  label: "设计方案名称",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "contactPerson",
                  label: "关联人",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "关联时间",
                  "min-width": "160",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.coolHomeDialogVisible,
            fullscreen: "",
            "append-to-body": "",
            "show-close": false,
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.coolHomeDialogVisible = $event
            },
            close: _vm.handleCoolHomeDialogClose,
          },
        },
        [
          _c("template", { slot: "title" }, [
            _c(
              "div",
              { staticClass: "dialog-title" },
              [
                _c("span", [_vm._v("酷家乐设计")]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: {
                      "margin-left": "auto",
                      "margin-right": "60px",
                    },
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.handleCoolHomeClose },
                  },
                  [_vm._v("完成设计并关闭")]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cool-home-container" }, [
            _c("iframe", { attrs: { src: _vm.coolHomeFrameUrl } }),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }